import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { ResponsiveService } from '@frk/eds-components';
import { LiteratureDocumentListingService } from '../../literature-document-listing/services/literature-document-listing.service';
import {
  ColDef,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import {
  LitCardSection,
  LiteratureDocument,
  LiteratureDocumentListingData,
  RendererData,
} from '@types';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';

@Component({
  selector: 'ft-literature-document-card',
  templateUrl: './literature-document-card.component.html',
  styleUrls: ['./literature-document-card.component.scss'],
})
export class LiteratureDocumentCardComponent implements OnChanges, OnInit {
  @Input() rowData: LiteratureDocumentListingData;
  @Input() columnDefs: ColDef[];
  @Input() gridContext: any;
  convertDateTo: string;
  isIntel: boolean;
  rendererData: RendererData = { data: {} };
  renderParams: RendererData = {};
  @Output()
  selectionEmitter = new EventEmitter<LiteratureDocumentListingData>();

  finalRow: LitCardSection[] = [];
  isMobile$: Observable<boolean>;

  constructor(
    @Inject(WINDOW) readonly windowRef: Window,
    private literatureDocumentListingService: LiteratureDocumentListingService,
    private literatureConfig: LiteratureGlobalConfigService,
    protected responsiveService: ResponsiveService
  ) {}

  ngOnInit() {
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngOnChanges() {
    if (this.rowData && this.columnDefs && this.columnDefs.length > 0) {
      this.processSections();
    }
    this.rendererData = this.renderParams;
    this.rendererData.data = this.rowData;
    if (!this.isIntel) {
      this.rendererData = {
        ...this.rendererData,
        ...{ showPublicationDate: true },
      };
    }
  }

  public processSections(): void {
    this.convertDateTo = this.literatureConfig.dateFormat;
    this.isIntel = this.literatureConfig.isInternational;
    this.finalRow = [];
    this.columnDefs.forEach((col) => {
      this.finalRow.push(this.processCol(col));
    });
  }

  goToLink(litData: LiteratureDocument) {
    this.windowRef.open(
      litData?.cmsExternalLink
        ? litData?.cmsExternalLink
        : this.literatureDocumentListingService.getDownloadUrl(
            litData?.literatureHref
          ),
      '_blank'
    );
  }

  processCol(colDef: ColDef): LitCardSection {
    const colId = colDef.colId || '';
    const label = colDef.headerName || '';
    let val;
    if (colDef.cellRendererParams) {
      this.renderParams = {
        ...colDef.cellRendererParams,
        ...this.renderParams,
      };
    }
    if (colDef.valueFormatter) {
      if (typeof colDef.valueFormatter === 'string') {
        val = colDef.valueFormatter;
      } else {
        val = colDef.valueFormatter({
          data: this.rowData,
          value: this.rowData.literatureData.frkReferenceDate,
          context: this.gridContext,
        } as ValueFormatterParams);
      }
    } else if (colDef.valueGetter) {
      if (typeof colDef.valueGetter === 'string') {
        val = colDef.valueGetter;
      } else {
        val = colDef.valueGetter({
          data: this.rowData,
          context: this.gridContext,
        } as ValueGetterParams);
      }
    } else if (colDef.cellRenderer) {
      if (typeof colDef.cellRenderer === 'string') {
        val = colDef.cellRenderer;
      } else {
        // TODO
      }
    }
    // TODO: extract caveats and tooltips
    return {
      colId,
      label,
      val,
    };
  }
  onSelectionChanged(event: Event, data: LiteratureDocumentListingData) {
    this.rowData.literatureData.isSelected = !this.rowData.literatureData
      .isSelected;
    this.selectionEmitter.emit(data);
  }
}
